import "../css/styles.scss"

// Smooth scrolling + all page interactions are owned by the theme-blocks engine
// (GSAP + ScrollTrigger + Lenis), enqueued by the plugin. No Lenis here to avoid
// running two competing smooth-scroll instances.
